var indentation_default = {
  "indentZero": "WcxKu",
  "indentOne": "tjBvz",
  "indentTwo": "P0QxZ",
  "indentThree": "bkBUW",
  "indentFour": "qB4xa",
  "indentFive": "Y08vj",
  "indentSix": "dX5wI"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
